import './tagsStyles.scss';

const Tags = ({ text, type = 'default' }) => {
    return (
      <div className='tags'>
        <div className={`tag tag--${type}`}>
          {text}
        </div>
      </div>
  );
};

export default Tags;